import { isMessage } from '@deephaven/utils';
export { /** @deprecated Use `@deephaven/utils` `getWindowParent` instead. */
getWindowParent, /** @deprecated Use `@deephaven/utils` `isMessage` instead. */
isMessage, /** @deprecated Use `@deephaven/utils` `isResponse` instead. */
isResponse, /** @deprecated Use `@deephaven/utils` `makeMessage` instead. */
makeMessage, /** @deprecated Use `@deephaven/utils` `makeResponse` instead. */
makeResponse, /** @deprecated Use `@deephaven/utils` `requestParentResponse` instead. */
requestParentResponse
/** @deprecated Use `@deephaven/utils` `PostMessage<T>` instead. */ } from '@deephaven/utils';
export var LOGIN_OPTIONS_REQUEST = 'io.deephaven.message.LoginOptions.request';
export var SESSION_DETAILS_REQUEST = 'io.deephaven.message.SessionDetails.request';

/**
 * Use a BroadcastChannel for sending messages between tabs, such as when the user logs out.
 */
export var BROADCAST_CHANNEL_NAME = 'io.deephaven.broadcast';

/**
 * Event emitted when the user has logged in successfully
 */
export var BROADCAST_LOGIN_MESSAGE = 'io.deephaven.broadcast.Login';

/**
 * Event emitted when the user has logged out
 */
export var BROADCAST_LOGOUT_MESSAGE = 'io.deephaven.broadcast.Logout';
export function isBroadcastLoginMessage(obj) {
  return isMessage(obj) && obj.message === BROADCAST_LOGIN_MESSAGE;
}
export function isBroadcastLogoutMessage(obj) {
  return isMessage(obj) && obj.message === BROADCAST_LOGOUT_MESSAGE;
}
//# sourceMappingURL=MessageUtils.js.map